/*!
 *
 * tab-navigator.js
 *
 */

var tab = function(_this, opt){
	this.$nav = $(_this).find('a');
	this.setting = $.extend({}, this.default, opt);
	this.hash = location.hash;
	this.init();
};

tab.prototype = {
	init: function(){
		var self = this;
		var contents = [],
			head = [],
			active = '';
		this.$nav.each(function(){
			var _href = $(this).attr('href');
			contents.push( _href );
			head.push('a[href="'+ _href +'"]');
			if( self.hash == _href ){
				active = _href;
			};
		});
		this.$contents = $(contents.join(','));
		this.$head = $(head.join(','), this.setting.head);
		this.offsetClass = this.setting.offsetClass;

		if( active == '' ){
			active = this.$nav.filter(function(i){
				return i == 0;
			}).attr('href');
		};
		this.toggle( active )
		this.setAction();
	},
	setAction: function(){
		var self = this;
		this.$nav.on('tap', function(e){
			e.preventDefault();
			if( $(this).is( self.setting.active ) ) return false;
			var _href = $(this).attr('href');
			self.toggle(_href);
		});

		this.$head.on('tap', function(e){
			e.preventDefault();
			var _href = $(this).attr('href');
			if( $(this).is( self.setting.active ) ){
				self.slideHide(_href);
			}else{
				self.slideToggle(_href, this);
			};
		});
	},
	toggle: function( active ){
		var self = this,
			activeClass = this.setting.active.replace(/\./, '');
		this.$contents.hide(0).removeClass(activeClass);
		$(active).show(0).addClass(activeClass);
		this.$nav.each(function(){
			var _href = $(this).attr('href');
			if( _href == active ){
				$(this).addClass(activeClass);
			}else{
				$(this).removeClass(activeClass);
			};
		});
		this.$head.each(function(){
			var _href = $(this).attr('href');
			if( _href == active ){
				$(this).addClass(activeClass);
			}else{
				$(this).removeClass(activeClass);
			};
		});
	},
	slideToggle: function( active, _this ){
		var self = this,
			activeClass = this.setting.active.replace(/\./, '');
		this.$contents.slideUp(500).removeClass(activeClass);
		$(active).slideDown(500, function() {
			var _top = $(_this).parent().offset().top - 100;
			$(origin.st).animate({
				scrollTop: _top
			}, 500);
		}).addClass(activeClass);

		this.$nav.each(function(){
			var _href = $(this).attr('href');
			if( _href == active ){
				$(this).addClass(activeClass);
			}else{
				$(this).removeClass(activeClass);
			};
		});
		this.$head.each(function(){
			var _href = $(this).attr('href');
			if( _href == active ){
				$(this).addClass(activeClass);
			}else{
				$(this).removeClass(activeClass);
			};
		});
	},
	slideHide: function(){
		var activeClass = this.setting.active.replace(/\./, '');
		this.$contents.slideUp(500).removeClass(activeClass);
		this.$nav.removeClass(activeClass);
		this.$head.removeClass(activeClass);
	},
	default: {
		head: '.tab_head',
		active: '.active',
		offsetClass: '.top_contents_inner'
	}
};

$.fn.tabNavigator = function(options){
	var opt = options ? options : {};
	return this.each(function(){
		new tab(this,opt);
	});
};



//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/tab-navigator.js
// module id = 15
// module chunks = 0